import React from 'react';
import Router from "@nav/Router";

import Header from "@layout/Header";

export default function DashBoard() {

    return (
        <>
            <Header />
            <Router />
        </>
    )
}
